import { ActionIcon, Group, Text } from '@cowbell/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import styles from './ComparablesPanel.module.css';

interface ComparablesPanelProps {
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly children: React.ReactNode;
  readonly width?: number;
  readonly chatWidth?: number;
  readonly chatRight?: number;
}

export default function ComparablesPanel({
  isOpen,
  onClose,
  children,
  width = 480,
  chatWidth,
  chatRight = 0,
}: Readonly<ComparablesPanelProps>) {
  if (!isOpen) return null;

  const rightOffset =
    chatWidth === undefined ? undefined : chatWidth + chatRight;
  const panelClassName =
    rightOffset === undefined
      ? styles.panel
      : `${styles.panel} ${styles.docked}`;

  return (
    <div
      className={panelClassName}
      style={{ width: `${width}px`, right: rightOffset }}
    >
      <Group className={styles.header} justify="space-between">
        <Text fw={600} size="md">
          Comparables
        </Text>
        <ActionIcon variant="subtle" size="sm" onClick={onClose}>
          <FontAwesomeIcon icon={faXmark} />
        </ActionIcon>
      </Group>
      <div className={styles.content}>{children}</div>
    </div>
  );
}
